import { render, staticRenderFns } from "./workUpload.vue?vue&type=template&id=3c77f4c9&scoped=true"
import script from "./workUpload.vue?vue&type=script&lang=js"
export * from "./workUpload.vue?vue&type=script&lang=js"
import style0 from "./workUpload.vue?vue&type=style&index=0&id=3c77f4c9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c77f4c9",
  null
  
)

export default component.exports